import { OuSelector } from './homeOuSelector';

require('./homeOuSelector.scss');

export const myHomeOuSelectorComponent = {
  template: require('./homeOuSelector.html'),
  controllerAs: 'ctrl',
  controller: OuSelector,
};
